export function getAlphaIndex(index) {
    const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    if (index < alpha.length) {
        return alpha.charAt(index);
    }

    let mul = 1;
    // alpha.length + 1 => +1 for return string
    for (let i = mul; i <= alpha.length + 1; i++) {
        if (i * alpha.length <= index) {
            mul = i;
        } else {
            return `${alpha.charAt(mul - 1)}${alpha.charAt(index - mul * alpha.length)}`;
        }
    }
}
